import React from "react";
import "./styles.less";

import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";

import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";
import { IdentifyReason } from "./IdentifyReason";

import { ZeroCompliance } from "./ZeroCompliance";
import { ZeroOther } from "./ZeroOther";
import { IdentifyEvent } from "./IdentifyEvent";
import { IdentifyLog } from "./IdentifyLog";
import { IdentityMarquee } from "./IdentityMarquee";
import { IndentifyLayout } from "./IdentifyLayout";
import { IdentityBanner } from "./IdentityBanner";

export const logoLists = [
  [
    {
      title: "阿里云",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_aliyun.png",
      content: "阿里云",
    },
    {
      title: "GitLab",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_gitlab.png",
      content: "GitLab",
    },
    {
      title: "腾讯云",
      logo:
        "//files.authing.co/authing-website/open/applications/icon_tencent_cloud-2.png",
      content: "腾讯云",
    },
    {
      title: "飞书",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_feishu.png",
      content: "飞书",
    },
    {
      title: "华为云",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_huaweiyun.png",
      content: "华为云",
    },
    {
      title: "北森",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_beisen.png",
      content: "北森",
    },
    {
      title: "Notion",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_notion.png",
      content: "Notion",
    },
  ],
  [
    {
      title: "Jira",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_jirasoftwar.png",
      content: "Jira",
    },
    {
      title: "Moka",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_moka.png",
      content: "Moka",
    },
    {
      title: "飞连",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_feilian.png",
      content: "飞连",
    },
    {
      title: "JumpServer",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_jumpserver.png",
      content: "JumpServer",
    },
    {
      title: "Zoom",
      logo:
        "//files.authing.co/authing-website/open/applications/logo_zoom.png",
      content: "Zoom",
    },
    {
      title: "AWS",
      logo: "//files.authing.co/authing-website/open/applications/logo_aws.png",
      content: "AWS",
    },
    {
      title: "Gerrit",
      logo:
        "//files.authing.co/authing-website/open/applications/gerrit-logo.png",
      content: "Gerrit",
    },
  ],
];

export const IdentityAutomationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="zero-trust-page">
      <Helmet>
        <title>
          用自动化的统一身份认证管理流程，减低身份治理成本｜Authing身份云
        </title>
      </Helmet>
      <Header mode="dark" hasNotice special />
      <IdentityBanner />
      <IdentifyReason />
      <IdentifyEvent />
      <IndentifyLayout />
      <IdentifyLog />
      <IdentityMarquee />
      <ZeroCompliance />
      <ZeroOther />
      <Footer />
    </div>
  );
};
